import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Smoothly scrolls to the element matching the URL hash on route changes.
 * Handles navigating from any route to /#section or /contact#inquiry-form.
 */
export default function useHashScroll() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      // No hash → scroll to top on route change
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
      return;
    }
    const id = hash.replace("#", "");
    let attempts = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else if (attempts < 20) {
        attempts += 1;
        setTimeout(tick, 80);
      }
    };
    // Slight delay to let the new page mount
    const t = setTimeout(tick, 100);
    return () => clearTimeout(t);
  }, [hash, pathname]);
}
